import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ViewContainerRef } from '@angular/core';
import { CommonService } from '../../../../../commons/services/common.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ColorPickerService, Cmyk } from 'ngx-color-picker';
import moment from 'moment';
declare var $: any;

@Component({
    selector: 'app-edit-personnel',
    templateUrl: './edit-personnel.component.html',
    styleUrls: ['./edit-personnel.component.css'],
    standalone: false
})
export class EditPersonnelComponent implements OnInit {

  @Input() personnel: any = {};
  @Input() isInterim;
  @Input() listAssoChauffeursCompteurRH = [];
  @Output() hidefunction = new EventEmitter<any>();
  @ViewChild('msg') msg;
  @ViewChild('JoursTravaille') JoursTravaille;
  activeTab = 'tab1';
  @ViewChild('supprimerDocumentConfirme') supprimerDocumentConfirme;

  error = '';
  listCivilite = [];
  dataCamion = [];
  listActiviteSociete = [];
  listTypeContrat = [];
  listFacturation = [];
  dataAgence = [];
  listModulation = [];
  dataSousTraitant = [];
  dataTransporteur = [];
  dateTmp: any = '';
  listLangue = [];
  listPont = [];
  objFileObject: any = {};
  SearchCarract = 'default';
  dateMin
  dateMaxN
  listSemaine = [
    { id: 2, libelleObjetEntite: 'LUN' },
    { id: 3, libelleObjetEntite: 'MAR' },
    { id: 4, libelleObjetEntite: 'MER' },
    { id: 5, libelleObjetEntite: 'JEU' },
    { id: 6, libelleObjetEntite: 'VEN' },
    { id: 7, libelleObjetEntite: 'SAM' },
    { id: 1, libelleObjetEntite: 'DIM' },
  ];



  adresseAutoBAK: Boolean = false;
  isEmpty: Boolean = false;
  dataAdresseBAK: any[] = [];
  listeSite: any[] = [];
  listeQualif: any[] = [];
  resultZone: any[] = [];
  listChauffeur: any[] = [];
  droitContrat: Boolean = false;
  delay;
  societe = {};
  isCycleTravail: Boolean = false;
  isGestionCompteurRH: Boolean = false;
  isMatriculeAutoInterimaire: Boolean = false;
  listCycleTravail = [];
  documents: any[] = [];
  typeDocuments: any[] = [];
  documentSelected: any;
  dataArticle = [];
  dataExutoire = [];
  isPrestationAssociees: Boolean = false;
  listePrestationAssociees: any = [];
  isFiliereDepartement: Boolean = false;
  listeFiliereDepartement: any = [];
  listFiliereFact = [];
  add: Boolean = false
  edit: Boolean = false
  visionCouleur: Boolean = false
  constructor(public common: CommonService, private modalService: BsModalService,
    private cpService: ColorPickerService, public vcRef: ViewContainerRef) {
  }

  ngOnInit() {
    this.personnel = this.personnel || {};
    if (this.personnel['id']) {
      this.add = false
      this.edit = true
    } else {
      this.add = true
      this.edit = false
    }
    this.dateMin = this.common.parseDate('01/01/1950');
    const currentDate = moment();
    const maxDate = currentDate.add(1, 'year');
    this.dateMaxN = this.common.parseDate(maxDate.format('DD/MM/YYYY'));
    this.common.visibleChamp = this.common.visibleChamp || {};
    this.common.visibleChamp.persObj14 = this.common.visibleChamp.persObj14 || {};
    this.visionCouleur = this.common.visibleChamp.persObj14.vision
    const user = this.common.local.getObject('userDetail') || {};
    this.droitContrat = (user.clefDroit4 & 0x20000000) !== 0 ? true : false;
    const societe = this.common.local.getObject('paramSociete') || {};
    this.societe = societe;
    this.isCycleTravail = societe.cycleTravail || false;
    this.isGestionCompteurRH = societe.isGestionCompteurRH || false;
    this.isMatriculeAutoInterimaire = societe.matriculeAutoInterimaire || false;
    const site = this.common.getType('siteUtilisateur');
    const adresseAutoBAK = site['rechercheAdresse'] && (site['serviceAdresse'] &&
      site['serviceAdresse'].typeServiceAdresse &&
      site['serviceAdresse'].typeServiceAdresse.id === 2) ? true : false;
    this.adresseAutoBAK = (societe['rechercheAdresse'] && (societe['serviceAdresse'] &&
      societe['serviceAdresse'].typeServiceAdresse &&
      societe['serviceAdresse'].typeServiceAdresse.id === 2)) || adresseAutoBAK;
    this.listeSite = this.common.local.getObject('listeSite') || [];
    this.getListQualification();
    this.searchZone();
    this.searchSite();
    this.searchCycleTravail();
    this.searchTypeContrat('');
    // this.searchSousTraitant('');
    // this.searchTransporteur('');
    if (!this.listeSite) {
      this.getListeSite();
    }

    if (this.personnel['id']) {
      this.getDetail(this.personnel['id']);
      this.getDocsChauffeur(this.personnel['id'] || 0);
      this.getTypeDoc();
      console.log(this.personnel);
    } else {
      this.personnel['listJourSemaine'] = this.personnel['listJourSemaine'] || []
      this.personnel['clefSite'] = this.common.user[2]
      if (this.isInterim) {
        this.personnel['interimaire'] = true;
        this.personnel['clefSite'] = this.common.user[2];
      }



      this.searchModulation();
      this.personnel['listCompteurRH'] = this.listAssoChauffeursCompteurRH;
    }

  }

  returnList() {
    this.hidefunction.emit();
  }

  searchCivilite() {
    this.listCivilite = [{ id: 0, libelleObjetEntite: 'Aucune', libelle: 'Aucune' }];
    const list = this.common.getType('typeCivilite') || [];
    list.forEach(elt => {
      elt.libelleObjetEntite = elt.libelle;
      this.listCivilite.push(elt);
    });
  }

  searchAdresseBAK(event) {
    this.dataAdresseBAK = [];
    const param = {
      'servlet': 'DBGestionAdresseRecherche',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'CHAINE_RECHERCHE': event
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        this.dataAdresseBAK = datas.data;
        this.dataAdresseBAK.forEach(elt => {
          elt.id = elt.clefBAK;
          elt.libelleObjetEntite = elt.label;
        });
      }
    });
  }

  setValueAdresseBAK(value, name?) {
    if (value && (!value.numero || (value.numero && value.numero === '0'))) {
      value.numero = '';
    }

    this.personnel['adresse1'] = `${value.numero || ''} ${value.suffixe || ''}`;
    this.personnel['adresse2'] = `${value.typeVoie || ''} ${value.nomVoie || ''}`;
    this.personnel['adresse3'] = '';
    this.personnel['codePostal'] = value.postcode;
    this.personnel['ville'] = value.city;
    this.personnel['clefBAK'] = value.clefBAK;
    this.common.bak = value;
  }

  searchCamionNew(event) {
    this.SearchCarract = event;
    this.dataCamion = [{ id: 0, libelleObjetEntite: 'Aucun', libelle: 'Aucun' }];
    const param = {
      'servlet': 'DBGetListCamionSite',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': this.personnel.clefSite || this.common.user[2] || 0
        },
        'CRITERE': event
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        if (!datas.message) {
          this.dataCamion = [...this.dataCamion, ...datas.data];
          this.dataCamion.forEach(elt => {
            if (elt.id) {
              if (elt.numParc) {
                elt.libelleObjetEntite = elt.numParc + '/' + elt.immatriculation;
              } else {
                elt.libelleObjetEntite = elt.immatriculation;
              }
            }

          })
        } else {
          this.error = datas.message;
          this.common.openModal(this.modalService, this.msg);
        }
      }

    });
  }

  searchCamion(event) {
    this.searchCamionNew(event);
  }

  setCamion(event) {
    this.getCamion(event.id);
  }

  getCamion(id) {
    const param = {
      'servlet': 'DBGetCamion',
      'module': 'Recylog',
      'type': 'tableau',
      'compression': 'false',
      'data': ['DBGetCamion', '' + id]
    };

    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        const data = datas.data.length ? datas.data[0] : {};
        this.personnel['camion'] = data || {};
      }
    });
  }

  getDetail(id) {
    const param = {
      'servlet': 'DBGetChauffeur',
      'module': 'Recylog',
      'type': 'tableau',
      'compression': 'false',
      'forcerSerialisation': 'true',
      'data': ['DBGetChauffeur', '' + id]
    };

    this.common.post('', { param: param }, true).then(dt => {
      if (dt.message) {
        this.error = dt.message;
        this.common.openModal(this.modalService, this.msg);
      } else {
        this.personnel = dt.data[0];
        this.personnel.dateNaissance = this.personnel.dateNaissance ? this.personnel.dateNaissance : '01/01/2000 00:00:00';
        // this.personnel.dateNaissance = this.personnel.dateNaissance.replace(' 00:00:00', '');
        this.personnel.validitePermis = this.parseDate(this.personnel.validitePermis, '00/00/0000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.dateExpirationPermisPL = this.parseDate(this.personnel.dateExpirationPermisPL, '31/12/9999', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.dateExpirationPermisSPL = this.parseDate(this.personnel.dateExpirationPermisSPL, '31/12/9999', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.fimo = this.parseDate(this.personnel.fimo, '31/12/9999', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.fcos = this.parseDate(this.personnel.fcos, '31/12/9999', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.apth = this.parseDate(this.personnel.apth, '31/12/9999', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.dateDerniereVisiteMedicale = this.parseDate(this.personnel.dateDerniereVisiteMedicale, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.dateValiditeVisiteMedicale = this.parseDate(this.personnel.dateValiditeVisiteMedicale, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.dateADR = this.parseDate(this.personnel.dateADR, '31/12/9999', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.UICPR1 = this.parseDate(this.personnel.UICPR1, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.UICPR2 = this.parseDate(this.personnel.UICPR2, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.CACES1 = this.parseDate(this.personnel.CACES1, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.CACES2 = this.parseDate(this.personnel.CACES2, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.CACES3 = this.parseDate(this.personnel.CACES3, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.CACES4 = this.parseDate(this.personnel.CACES4, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.CACES5 = this.parseDate(this.personnel.CACES5, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.CACES6 = this.parseDate(this.personnel.CACES6, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.CACES7 = this.parseDate(this.personnel.CACES7, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.CACES8 = this.parseDate(this.personnel.CACES8, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.CACES9 = this.parseDate(this.personnel.CACES9, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.CACES10 = this.parseDate(this.personnel.CACES10, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.CACESGrueTourGMACabine = this.parseDate(this.personnel.CACESGrueTourGMACabine, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.CACESGrueTourGME = this.parseDate(this.personnel.CACESGrueTourGME, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.CACESGrueTourRelevable = this.parseDate(this.personnel.CACESGrueTourRelevable, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.CACESGrueTourGMASol = this.parseDate(this.personnel.CACESGrueTourGMASol, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.CACESGrueTourMobile1A = this.parseDate(this.personnel.CACESGrueTourMobile1A, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.CACESGrueTourMobile1B = this.parseDate(this.personnel.CACESGrueTourMobile1B, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.CACESGrueTourMobile2A = this.parseDate(this.personnel.CACESGrueTourMobile2A, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.CACESGrueTourMobile2B = this.parseDate(this.personnel.CACESGrueTourMobile2B, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.CACESGrueTourMobile2C = this.parseDate(this.personnel.CACESGrueTourMobile2C, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.CACESMobilePersonnel1A = this.parseDate(this.personnel.CACESMobilePersonnel1A, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.CACESMobilePersonnel1B = this.parseDate(this.personnel.CACESMobilePersonnel1B, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.CACESMobilePersonnel2A = this.parseDate(this.personnel.CACESMobilePersonnel2A, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.CACESMobilePersonnel2B = this.parseDate(this.personnel.CACESMobilePersonnel2B, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.CACESMobilePersonnel3A = this.parseDate(this.personnel.CACESMobilePersonnel3A, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.CACESMobilePersonnel3B = this.parseDate(this.personnel.CACESMobilePersonnel3B, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.CACESManutConduct1 = this.parseDate(this.personnel.CACESManutConduct1, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.CACESManutConduct2 = this.parseDate(this.personnel.CACESManutConduct2, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.CACESManutConduct3 = this.parseDate(this.personnel.CACESManutConduct3, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.CACESManutConduct4 = this.parseDate(this.personnel.CACESManutConduct4, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.CACESManutConduct5 = this.parseDate(this.personnel.CACESManutConduct5, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.CACESManutConduct6 = this.parseDate(this.personnel.CACESManutConduct6, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.CACESGrueAux = this.parseDate(this.personnel.CACESGrueAux, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.SST = this.parseDate(this.personnel.SST, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.formationIncendie = this.parseDate(this.personnel.formationIncendie, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.formationRisqueBio = this.parseDate(this.personnel.formationRisqueBio, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.amiante = this.parseDate(this.personnel.amiante, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.dateExpirationCarteSejour = this.parseDate(this.personnel.dateExpirationCarteSejour, '31/12/9999', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.dateCarteChrono = this.parseDate(this.personnel.dateCarteChrono, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');

        const todayDateFR = moment(new Date()).format('DD/MM/YYYY');
        this.personnel.dateEntree = this.parseDate(this.personnel.dateEntree, todayDateFR, 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.dateSortie = this.parseDate(this.personnel.dateSortie, todayDateFR, 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.CACESMobilePersonne1A = this.parseDate(this.personnel.CACESMobilePersonne1A, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.CACESMobilePersonne1B = this.parseDate(this.personnel.CACESMobilePersonne1B, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.CACESMobilePersonne2A = this.parseDate(this.personnel.CACESMobilePersonne2A, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.CACESMobilePersonne2B = this.parseDate(this.personnel.CACESMobilePersonne2B, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.CACESMobilePersonne3A = this.parseDate(this.personnel.CACESMobilePersonne3A, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel.CACESMobilePersonne3B = this.parseDate(this.personnel.CACESMobilePersonne3B, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');

        this.personnel['couleur'] = this.personnel['couleur'] ? '#' + this.personnel['couleur'] : '';
        this.personnel['listeContrat'] = this.personnel['listeContrat'] || [];

        if (!this.personnel['camion'] || (this.personnel['camion'] && !this.personnel['camion'].id)) {
          this.personnel['camion'] = { id: 0, libelleObjetEntite: 'Aucun', libelle: 'Aucun' };
        }

        this.personnel['listJourSemaine'] = this.personnel['listJourSemaine'] || [];
        this.personnel.dateNaissance = this.parseDate(this.personnel.dateNaissance, '01/01/2000', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY');
        this.personnel['listeContrat'].forEach(elt => {
          elt.dateDebut = elt.dateDebut || '01/01/2000';
          elt.dateFin = elt.dateFin || '31/12/9999';

          elt.dateDebut = moment(elt.dateDebut, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY');
          elt.dateFin = moment(elt.dateFin, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY');

          if (this.isCycleTravail) {
            if (!elt.cycleTravail) {
              elt.dateDebutCycleTravail = '';
            }

            if (elt.dateDebutCycleTravail) {
              elt.dateDebutCycleTravail = elt.dateDebutCycleTravail || '01/01/2000';
              elt.dateDebutCycleTravail = moment(elt.dateDebutCycleTravail, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY');
            }

          }
        });

        this.listTypeContrat.forEach(elt => {
          if (this.personnel['typeContratPersonnel'] && elt.id === this.personnel['typeContratPersonnel'].id) {
            this.personnel['typeContratPersonnel'] = elt;
          }
        });

        const listFacturationInterim = this.common.getType('facturationInterim') || [];
        listFacturationInterim.forEach(element => {
          const idFactInterim = this.personnel.facturationInterim ? this.personnel.facturationInterim.id : ''
          if (element.id === idFactInterim) {
            this.personnel['facturationInterim'].libelleObjetEntite = element.libelle || element.libelleObjetEntite
          }
        });

        if (!this.personnel['typeContratPersonnel']) {
          this.personnel['typeContratPersonnel'] = this.listTypeContrat[0];
        }


        const list = this.common.getType('typeCivilite') || [];
        list.forEach(elt => {
          if (this.personnel.civilite && this.personnel.civilite.id === elt.id) {
            this.personnel.civilite = elt;
          }
        });

        this.resultZone.forEach(elt => {
          if (this.personnel['zone'] && this.personnel['zone'].id === elt.id) {
            this.personnel['zone'] = elt;
          }
        })

        if (this.personnel['chauffeurChef']) {
          this.personnel['chauffeurChef']['libelleObjetEntite'] = (this.personnel['chauffeurChef']['nom'] ? this.personnel['chauffeurChef']['nom'] : '') +
            (this.personnel['chauffeurChef']['prenom'] ? ' ' + this.personnel['chauffeurChef']['prenom'] : '')
        }

        this.common.getDetailBak(this.adresseAutoBAK, this.personnel['clefBAK']);
        this.searchModulation();

        if (this.isGestionCompteurRH && this.personnel['listCompteurRH']) {
          this.personnel['listCompteurRH'].forEach(c => {
            if (!c.valeur) {
              c.valeur = 0;
            }
          });
        }

        if (this.personnel['listeArticleImport'] && this.personnel['listeArticleImport'].length) {
          this.personnel['listeArticleImport'].forEach(s => {
            if (s.article && s.article.id) {
              s.article.libelleObjetEntite = `${s.article.code ? (s.article.code + '/') : ''}${s.article.libelle || ''}`;
            }
          });
        }
      }
    });
  }

  parseDate(date, defaultValue, ancienFormat, newFormat) {
    return date ? ((date === defaultValue) ? '' : this.common.parseDate(moment(date, ancienFormat).format(newFormat))) : '';
  }

  changeDate(event, type) {
    //this.personnel[type] = event;
    if (event && moment(event).isValid()) {
      this.personnel[type] = event;
    } else {
      this.personnel[type] = '';
    }
  }

  changeDateNaissance(event, type) {
    if (event && moment(event).isValid()) {
      this.personnel[type] = this.common.parseDate(moment(event, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY'))
    } else {
      this.personnel[type] = '';
    }
  }

  changeDateContrat(event, type, row) {
    console.log("event", event)
    if (event && moment(event).isValid()) {
      row[type] = moment(event).format('DD/MM/YYYY');
    } else {
      row[type] = '';
    }
  }

  refactorHeureDebut() {
    if (this.personnel.heureDebut && this.personnel.heureDebut.length) {
      this.personnel.heureDebut = this.personnel.heureDebut.replaceAll(':', '')
      const isNumber = Number(this.personnel.heureDebut)
      if (!isNumber) {
        return false;
      }

      let key = this.personnel.heureDebut.length;

      switch (key) {
        case 1:
          this.personnel.heureDebut = this.personnel.heureDebut + ':' + '00';
          break;
        case 2:
          this.personnel.heureDebut = this.personnel.heureDebut + ':' + '00';
          break;

        case 3:
          const first1Carracter = this.personnel.heureDebut.slice(0, 2);
          const last1Carracter = this.personnel.heureDebut.slice(2, 3);
          this.personnel.heureDebut = first1Carracter + ':' + last1Carracter + '0';
          break;


        default:
          break;
      }

      if (key > 3) {
        const first2Carracter2 = this.personnel.heureDebut.slice(0, 2);
        const last2Carracter = this.personnel.heureDebut.slice(2, 4);
        this.personnel.heureDebut = first2Carracter2 + ':' + last2Carracter;
      }
    }
  }

  refactorHeureFin() {
    if (this.personnel.heureFin && this.personnel.heureFin.length) {
      this.personnel.heureFin = this.personnel.heureFin.replaceAll(':', '')
      let key = this.personnel.heureFin.length;
      const isNumber = Number(this.personnel.heureFin)
      if (!isNumber) {
        return false;
      }
      switch (key) {
        case 1:
          this.personnel.heureFin = this.personnel.heureFin + ':' + '00';
          break;
        case 2:
          this.personnel.heureFin = this.personnel.heureFin + ':' + '00';
          break;

        case 3:
          const first1Carracter = this.personnel.heureFin.slice(0, 2);
          const last1Carracter = this.personnel.heureFin.slice(2, 3);
          this.personnel.heureFin = first1Carracter + ':' + last1Carracter + '0';
          break;

        default:
          break;

      }

      if (key > 3) {
        const first2Carracter2 = this.personnel.heureFin.slice(0, 2);
        const last2Carracter = this.personnel.heureFin.slice(2, 4);
        this.personnel.heureFin = first2Carracter2 + ':' + last2Carracter;
      }
    }
  }

  searchActiviteSociete(event?) {
    this.listActiviteSociete = [];
    this.common.getType('typeActiviteSociete').forEach(elt => {
      // if (elt.libelle.startsWith(event) || elt.libelle.toLowerCase().startsWith(event)) {
      elt.libelleObjetEntite = elt.libelle;
      this.listActiviteSociete.push(elt);
      // }
    });
  }

  searchTypeContrat(event?) {
    this.listTypeContrat = [{ id: 0, libelle: 'Aucun', libelleObjetEntite: 'Aucun', code: '' }];
    let liste = this.common.getType('typeContrat') || [];

    liste.forEach(elt => {
      // if (elt.libelle.startsWith(event) || elt.libelle.toLowerCase().startsWith(event)) {
      elt.libelleObjetEntite = elt.libelleObjetEntite || '';
      this.listTypeContrat.push(elt);
      // }
    });
  }

  searchFacturationInterim(event?) {
    this.listFacturation = [];
    this.common.getType('facturationInterim').forEach(elt => {
      // if (elt.libelle.startsWith(event) || elt.libelle.toLowerCase().startsWith(event)) {
      elt.libelleObjetEntite = elt.libelle;
      this.listFacturation.push(elt);
      // }
    });
  }

  searchAgenceNew(event) {
    this.dataAgence = [];
    const param = 42;


    return this.common.appelComboK3Fct(param, event).then(datas => {
      if (this.common.verifySession(datas)) {
        this.dataAgence = [...this.dataAgence, ...datas.data];
      }
    });
  }

  searchAgence(event) {
    this.searchAgenceNew(event);
  }

  setAgence(event) {
    this.getAgence(event);
  }

  getAgence(id) {
    const param = {
      'servlet': 'DBGestionAgenceInterim',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 2
        },
        'CLEF_AGENCE': {
          'typeParam': 'int',
          'valeur': id.id
        }
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        const data = datas.data || id;
        this.personnel['agenceInterim'] = data || id;
      }
    });
  }

  searchModulation(event?) {
    const param = {
      'servlet': 'DBGestionModulationPersonnel',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 2
        }
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        this.listModulation = [...this.listModulation, ...datas.data];
        this.listModulation.forEach(elt => {
          elt.libelleObjetEntite = elt.libelle
          if (this.personnel && this.personnel['modulationPersonnel'] && this.personnel['modulationPersonnel'].id === elt.id) {
            this.personnel['modulationPersonnel'] = elt;
          }
        });
      }
    });
  }

  searchSousTraitant(event) {
    const param = 10;
    console.log('miantso combo')
    return this.common.appelComboK3Fct(param, event).then(datas => {
      if (this.common.verifySession(datas)) {
        const eventNotFirst = event.includes('/')
        const libelleSoustraitant = this.personnel.employeur ? (this.personnel.employeur.codeClient + '/' + this.personnel.employeur.nomClient) : '';
        const libelleAucun = [{ id: 0, libelleObjetEntite: 'Aucun' }];
        const defaultSousTraitant = [{ id: this.personnel.employeur ? this.personnel.employeur.id : 0, libelleObjetEntite: libelleSoustraitant }];
        this.dataSousTraitant = [...libelleAucun, ...datas.data];
        if (eventNotFirst) {
          this.dataSousTraitant = [...libelleAucun, ...defaultSousTraitant]
        }
        this.dataSousTraitant.forEach(elt => elt.libelleObjetEntite = elt.libelleObjetEntite || elt.libelle);
      }
    });
  }

  setSousTraitant(event) {
    if (event && event.id) {
      const param = {
        'servlet': 'DBGetClient',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'true',
        'data': {
          'CLEF_CLIENT': {
            'typeParam': 'int',
            'valeur': event.id || 0
          },
          'CLEF_SITE': {
            'typeParam': 'int',
            'valeur': this.common.user[2]
          },
          'LOAD_CHANTIER': {
            'typeParam': 'boolean',
            'valeur': false
          },
        }
      };

      return this.common.post('', { param: param }).then(datas => {
        if (this.common.verifySession(datas)) {
          const data = datas.data.length ? datas.data[0] : {};
          this.personnel['employeur'] = data || {};
        }
      });
    } else {
      this.personnel['employeur'] = { id: 0 };
    }
  }

  searchTransporteur(event) {
    const param = 43;

    return this.common.appelComboK3Fct(param, event).then(datas => {
      if (this.common.verifySession(datas)) {
        const libelleAucun = [{ id: 0, libelleObjetEntite: 'Aucun' }];
        this.dataTransporteur = [...libelleAucun, ...datas.data];
        this.dataTransporteur.forEach(elt => elt.libelleObjetEntite = elt.libelleObjetEntite || elt.libelle);
      }
    });
  }

  setTransporteur(event) {
    const param = {
      'servlet': 'DBGetTransporteur',
      'module': 'Recylog',
      'type': 'string',
      'compression': 'false',
      'data': '' + event.id
    };

    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        const data = datas.data.length ? datas.data[0] : { id: 0 };
        this.personnel['transporteur'] = data || { id: 0 };
      }
    });
  }

  searchLangue(event) {
    const param = 44;

    return this.common.appelComboK3Fct(param, event).then(datas => {
      if (this.common.verifySession(datas)) {
        this.listLangue = [...datas.data];
      }
    });
  }

  setLangue(event) {
    this.personnel['langue'] = event || {};
  }

  searchPont(event) {
    const param = 55;

    return this.common.appelComboK3Fct(param, event).then(datas => {
      if (this.common.verifySession(datas)) {
        this.listPont = [...datas.data];
      }
    });
  }

  setPont(event) {
    this.personnel['pontBasculeChauffeur'] = event || {};
  }

  save() {
    // Vérification date naissance obligatoire
    if (!this.personnel['nom']) {
      this.error = ' Le champ Nom doit être non vide'
      this.common.openModal(this.modalService, this.msg);
      return false;
    }
    const iSdateNaissanceValid = (this.personnel['dateNaissance'] && (moment(this.personnel['dateNaissance']).isValid())) ? true : false
    if (!this.personnel['dateNaissance'] || !iSdateNaissanceValid) {
      this.error = 'Le format de la date de naissance n\'est pas valide (jj/MM/aaaa).';
      this.common.openModal(this.modalService, this.msg);
      return false;
    }
    this.personnel.dateNaissance = moment(this.personnel.dateNaissance, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY');

    const heureDebut = this.personnel.heureDebut;
    if (!!heureDebut && !heureDebut.includes(':')) {
      if (heureDebut.startsWith('0') && heureDebut.length > 1) {
        const minutes = heureDebut.substr(2, heureDebut.length).length === 1 ? heureDebut.substr(2, heureDebut.length) + '0' : heureDebut.substr(2, 2);
        this.personnel.heureDebut = heureDebut.substr(0, 2) + ':' + minutes;
      }
    }


    if (this.personnel.listeContrat) {
      this.personnel.listeContrat.forEach(c => {
        if (!c.dateFin || c.dateFin === '') {
          c.dateFin = '31/12/9999';
        }

        // Erreur sur les champs qualifications et sites
        if (c['erreurChamps']) {
          this.revertModif(c);
        }
      });
    }

    if (this.personnel['interimaire'] && (!this.personnel['agenceInterim'] ||
      (this.personnel['agenceInterim'] && !this.personnel['agenceInterim'].id))) {
      this.error = 'Le champ Agence est obligatoire.';
      this.common.openModal(this.modalService, this.msg);
      return false;
    }

    // this.personnel['couleur'] = (this.personnel['couleur'] || '').replace('#', '');

    this.personnel['nomclass'] = 'Chauffeur';
    this.getData();
    // if (this.SearchCarract != '') {
    //   this.personnel.camion = this.personnel.camion
    // } else {
    //   delete this.personnel.camion;
    // }
    const param = {
      'servlet': 'DBMAJChauffeur',
      'module': 'Recylog',
      'type': 'liste',
      'compression': 'false',
      'data': [this.personnel, '' + this.common.user[0]]
    };

    const ctrl = this;
    this.common.post('', { param: param }, true).then(dt => {
      if (dt.message) {
        ctrl.error = dt.message;
        ctrl.common.openModal(ctrl.modalService, ctrl.msg);
      } else if (dt.data === 'ERR_RAPPORT_1') {
        ctrl.error = 'Un problème est survenu lors de l\'enregistrement';
        ctrl.common.openModal(ctrl.modalService, ctrl.msg);
      } else if (dt.data == 'ERR_SETTING_TABLE_0') {
        this.common.closeModal();
        this.error = 'Il existe déja un personnel avec le même nom, prénom et matricule.';
        this.common.openModal(this.modalService, this.msg);
      } else if (dt.data === 'ERR_CODE_DUPLICATE_LOGINEDC2') {
        this.error = 'Un personnel avec le même login EDC2 existe déjà';
        ctrl.common.openModal(ctrl.modalService, ctrl.msg);
        this.activeTab = 'tab4'
      } else {
        const id = ctrl.personnel['id'];
        ctrl.common.createLog('16', dt.data, id ? false : true);
        ctrl.personnel['id'] = dt.data;
        ctrl.returnList();
      }
    });
  }

  getData() {
    this.personnel.dateNaissance = this.personnel.dateNaissance ? this.personnel.dateNaissance : '01/01/2000 00:00:00';//this.setDefaultValueDate(this.personnel.dateNaissance, '01/01/2000');
    this.personnel.validitePermis = this.personnel.permisVL ? this.setDefaultValueDate(this.personnel.validitePermis, '00/00/0000') : '00/00/0000';
    this.personnel.dateExpirationPermisPL = this.personnel.permisPL ? this.setDefaultValueDate(this.personnel.dateExpirationPermisPL, '31/12/9999') : '31/12/9999';
    this.personnel.dateExpirationPermisSPL = this.personnel.permisSPL ? this.setDefaultValueDate(this.personnel.dateExpirationPermisSPL, '31/12/9999') : '31/12/9999';
    this.personnel.fimo = this.personnel.FIMO ? this.setDefaultValueDate(this.personnel.fimo, '') : '';
    this.personnel.fcos = this.personnel.FCOS ? this.setDefaultValueDate(this.personnel.fcos, '') : '';
    this.personnel.apth = this.personnel.permisSPL ? this.setDefaultValueDate(this.personnel.apth, '') : '';
    this.personnel.dateDerniereVisiteMedicale = this.setDefaultValueDate(this.personnel.dateDerniereVisiteMedicale, '01/01/2000');
    this.personnel.dateValiditeVisiteMedicale = this.setDefaultValueDate(this.personnel.dateValiditeVisiteMedicale, '01/01/2000');
    this.personnel.dateADR = this.personnel.ADR ? this.setDefaultValueDate(this.personnel.dateADR, '31/12/9999') : '31/12/9999';
    this.personnel.UICPR1 = this.setDefaultValueDate(this.personnel.UICPR1, '01/01/2000');
    this.personnel.UICPR2 = this.personnel.UICPR1 !== '' ? this.setDefaultValueDate(this.personnel.UICPR2, '01/01/2000') : '01/01/2000';
    this.personnel.CACES1 = this.setDefaultValueDate(this.personnel.CACES1, '01/01/2000');
    this.personnel.CACES2 = this.setDefaultValueDate(this.personnel.CACES2, '01/01/2000');
    this.personnel.CACES3 = this.setDefaultValueDate(this.personnel.CACES3, '01/01/2000');
    this.personnel.CACES4 = this.setDefaultValueDate(this.personnel.CACES4, '01/01/2000');
    this.personnel.CACES5 = this.setDefaultValueDate(this.personnel.CACES5, '01/01/2000');
    this.personnel.CACES6 = this.setDefaultValueDate(this.personnel.CACES6, '01/01/2000');
    this.personnel.CACES7 = this.setDefaultValueDate(this.personnel.CACES7, '01/01/2000');
    this.personnel.CACES8 = this.setDefaultValueDate(this.personnel.CACES8, '01/01/2000');
    this.personnel.CACES9 = this.setDefaultValueDate(this.personnel.CACES9, '01/01/2000');
    this.personnel.CACES10 = this.setDefaultValueDate(this.personnel.CACES10, '01/01/2000');
    this.personnel.CACESGrueTourGMACabine = this.setDefaultValueDate(this.personnel.CACESGrueTourGMACabine, '01/01/2000');
    this.personnel.CACESGrueTourGME = this.setDefaultValueDate(this.personnel.CACESGrueTourGME, '01/01/2000');
    this.personnel.CACESGrueTourRelevable = this.setDefaultValueDate(this.personnel.CACESGrueTourRelevable, '01/01/2000');
    this.personnel.CACESGrueTourGMASol = this.setDefaultValueDate(this.personnel.CACESGrueTourGMASol, '01/01/2000');
    this.personnel.CACESGrueTourMobile1A = this.setDefaultValueDate(this.personnel.CACESGrueTourMobile1A, '01/01/2000');
    this.personnel.CACESGrueTourMobile1B = this.setDefaultValueDate(this.personnel.CACESGrueTourMobile1B, '01/01/2000');
    this.personnel.CACESGrueTourMobile2A = this.setDefaultValueDate(this.personnel.CACESGrueTourMobile2A, '01/01/2000');
    this.personnel.CACESGrueTourMobile2B = this.setDefaultValueDate(this.personnel.CACESGrueTourMobile2B, '01/01/2000');
    this.personnel.CACESGrueTourMobile2C = this.setDefaultValueDate(this.personnel.CACESGrueTourMobile2C, '01/01/2000');
    this.personnel.CACESMobilePersonnel1A = this.setDefaultValueDate(this.personnel.CACESMobilePersonnel1A, '01/01/2000');
    this.personnel.CACESMobilePersonnel1B = this.setDefaultValueDate(this.personnel.CACESMobilePersonnel1B, '01/01/2000');
    this.personnel.CACESMobilePersonnel2A = this.setDefaultValueDate(this.personnel.CACESMobilePersonnel2A, '01/01/2000');
    this.personnel.CACESMobilePersonnel2B = this.setDefaultValueDate(this.personnel.CACESMobilePersonnel2B, '01/01/2000');
    this.personnel.CACESMobilePersonnel3A = this.setDefaultValueDate(this.personnel.CACESMobilePersonnel3A, '01/01/2000');
    this.personnel.CACESMobilePersonnel3B = this.setDefaultValueDate(this.personnel.CACESMobilePersonnel3B, '01/01/2000');
    this.personnel.CACESManutConduct1 = this.setDefaultValueDate(this.personnel.CACESManutConduct1, '01/01/2000');
    this.personnel.CACESManutConduct2 = this.setDefaultValueDate(this.personnel.CACESManutConduct2, '01/01/2000');
    this.personnel.CACESManutConduct3 = this.setDefaultValueDate(this.personnel.CACESManutConduct3, '01/01/2000');
    this.personnel.CACESManutConduct4 = this.setDefaultValueDate(this.personnel.CACESManutConduct4, '01/01/2000');
    this.personnel.CACESManutConduct5 = this.setDefaultValueDate(this.personnel.CACESManutConduct5, '01/01/2000');
    this.personnel.CACESManutConduct6 = this.setDefaultValueDate(this.personnel.CACESManutConduct6, '01/01/2000');
    this.personnel.CACESGrueAux = this.setDefaultValueDate(this.personnel.CACESGrueAux, '01/01/2000');
    this.personnel.SST = this.setDefaultValueDate(this.personnel.SST, '01/01/2000');
    this.personnel.formationIncendie = this.setDefaultValueDate(this.personnel.formationIncendie, '01/01/2000');
    this.personnel.formationRisqueBio = this.setDefaultValueDate(this.personnel.formationRisqueBio, '01/01/2000');
    this.personnel.amiante = this.setDefaultValueDate(this.personnel.amiante, '01/01/2000');
    this.personnel.dateExpirationCarteSejour = this.setDefaultValueDate(this.personnel.dateExpirationCarteSejour, '31/12/9999');
    this.personnel.dateCarteChrono = this.setDefaultValueDate(this.personnel.dateCarteChrono, '01/01/2000');

    const todayDateFR = moment(new Date()).format('DD/MM/YYYY');
    this.personnel.dateEntree = this.setDefaultValueDate(this.personnel.dateEntree, todayDateFR);
    this.personnel.dateSortie = this.setDefaultValueDate(this.personnel.dateSortie, todayDateFR);
    this.personnel.CACESMobilePersonne1A = this.setDefaultValueDate(this.personnel.CACESMobilePersonne1A, '01/01/2000');
    this.personnel.CACESMobilePersonne1B = this.setDefaultValueDate(this.personnel.CACESMobilePersonne1B, '01/01/2000');
    this.personnel.CACESMobilePersonne2A = this.setDefaultValueDate(this.personnel.CACESMobilePersonne2A, '01/01/2000');
    this.personnel.CACESMobilePersonne2B = this.setDefaultValueDate(this.personnel.CACESMobilePersonne2B, '01/01/2000');
    this.personnel.CACESMobilePersonne3A = this.setDefaultValueDate(this.personnel.CACESMobilePersonne3A, '01/01/2000');
    this.personnel.CACESMobilePersonne3B = this.setDefaultValueDate(this.personnel.CACESMobilePersonne3B, '01/01/2000');
    if (this.personnel['listeContrat']) {
      this.personnel['listeContrat'].forEach(contrat => {
        if (!contrat.numContrat) {
          contrat.numContrat = '';
        }
      });
    }
  }

  setDefaultValueDate(date, defaultValue) {
    // console.log('date = ' + date , 'moment(date).format("DD/MM/YYYY") =' + moment(date).format('DD/MM/YYYY'));
    return date ? moment(date).format('DD/MM/YYYY') : defaultValue;
  }

  searchSite() {
    this.listeSite.forEach(elt => {
      elt.libelleObjetEntite = elt.nom;
    });
  }

  getListeSite() {
    const info = this.common.local.getObject('userDetail');
    this.common.post('', {
      param: {
        'servlet': 'DBGetListSiteUser',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'false',
        'data': {
          'NOM_UTILISATEUR': info.login,
          'IS_HOLDING': {
            'typeParam': 'boolean',
            'valeur': '0'
          }
        }
      }
    }).then(datas => {
      this.common.local.setObject('listeSite', datas.data[0]);
      this.listeSite = datas.data[0];
      this.searchSite();
    }).catch(error => console.log(error));
  }

  searchCycleTravail() {
    // const info = this.common.local.getObject('userDetail');
    this.common.post('', {
      param: {
        'servlet': 'DBGestionCycleTravail',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'false',
        'data': {
          'OPERATION': {
            'typeParam': 'int',
            'valeur': 3
          }
        }
      }
    }).then(datas => {
      this.listCycleTravail = datas.data;
      this.listCycleTravail.forEach(elt => elt.libelleObjetEntite = elt.nom);
    }).catch(error => console.log(error));
  }

  addLigneContrat() {
    const todayDateFR = moment(new Date()).format('DD/MM/YYYY');
    this.personnel['listeContrat'] = this.personnel['listeContrat'] || [];
    this.personnel['listeContrat'].push({
      id: 0,
      editLigne: true,
      add: true,
      start: this.common.parseDate(todayDateFR),
      end: this.common.parseDate(todayDateFR),
      dateFinEdit: todayDateFR
    });
    this.personnel['listeContrat'] = [...this.personnel['listeContrat']];

  }

  modifLigneContrat(row) {
    if (row.clefAssignation && row.clefAssignation !== 0) {
      this.error = 'Ce contrat est lié à une assignation d\'intérim. Vous ne pouvez plus le modifier.';
      this.common.openModal(this.modalService, this.msg);
    } else {
      row.editLigne = true;

      row.siteEdit = Object.assign({}, row.site);
      if (this.isCycleTravail) {
        row.dateDebutCycleTravailEdit = row.dateDebutCycleTravail;
        row.startCycleTravail = this.common.parseDate(row.dateDebutCycleTravail);
      }

      row.cycleTravailEdit = Object.assign({}, row.cycleTravail);
      row.qualificationEdit = Object.assign({}, row.qualification);
      row.numContratEdit = row.numContrat;
      row.dateDebutEdit = row.dateDebut;
      row.dateFinEdit = row.dateFin;
      row.start = this.common.parseDate(row.dateDebut);
      row.end = this.common.parseDate(row.dateFin);
    }
  }

  deleteLigneContrat(row) {
    if (row.clefAssignation && row.clefAssignation !== 0) {
      this.error = 'Ce contrat est lié à une assignation d\'intérim. Vous ne pouvez plus le modifier.';
      this.common.openModal(this.modalService, this.msg);
    } else {
      this.personnel['listeContrat'] = this.personnel['listeContrat'] || [];
      this.personnel['listeContrat'] = this.personnel['listeContrat'].filter(elt => elt !== row);
      if (this.personnel['listeContrat'].length) {
        const getSite = this.personnel['listeContrat'][this.personnel['listeContrat'].length - 1];
        this.personnel['clefSite'] = getSite && getSite.site ? getSite.site.id : this.personnel['clefSite'];
      }
    }
  }

  validerModif(row) {
    row['erreurChamps'] = false;
    let date = false;
    let dateD = '', dateF = '';

    console.log(row);
    if (!row['qualificationEdit'] || !row['qualificationEdit'].id) {
      this.error = 'Veuillez positionner la qualification';
      this.common.openModal(this.modalService, this.msg);
      row['erreurChamps'] = true;
      return false;
    }
    const todayDateFR = moment(new Date()).format('DD/MM/YYYY');
    row.dateDebutEdit = row.dateDebutEdit || todayDateFR;
    // if(row.typeContratPersonnel && row.typeContratPersonnel.id === 1) {
    row.dateFinEdit = row.dateFinEdit || '31/12/9999';
    // }
    const debutEdit = moment(row.dateDebutEdit, 'DD/MM/YYYY'); // moment(row.dateDebut, 'DD/MM/YYYY');
    const finEdit = moment(row.dateFinEdit, 'DD/MM/YYYY');
    if (row.dateDebutEdit && row.dateFinEdit && debutEdit.isAfter(finEdit)) {
      this.error = 'La date de fin ne peut pas être antérieure à celle de début';
      this.common.openModal(this.modalService, this.msg);
      row['erreurChamps'] = true;
      return false;
    }

    if (!row['siteEdit'] || !row['siteEdit'].id) {
      this.error = 'Veuillez positionner le site';
      this.common.openModal(this.modalService, this.msg);
      row['erreurChamps'] = true;
      return false;
    }

    if (this.isCycleTravail && row['cycleTravailEdit']) {
      console.log(row['cycleTravailEdit']);

      const debut = moment(row.dateDebutEdit, 'DD/MM/YYYY'); // moment(row.dateDebut, 'DD/MM/YYYY');
      const fin = moment(row.dateFinEdit, 'DD/MM/YYYY'); // moment(row.dateFin, 'DD/MM/YYYY');
      const c = moment(row.dateDebutCycleTravailEdit, 'DD/MM/YYYY'); // moment(row.dateDebutEdit, 'DD/MM/YYYY');

      if (c.isBefore(debut) || c.isAfter(fin)) {
        this.error = 'La date de début du cycle de travail ne rentre pas dans la période du contrat.';
        this.common.openModal(this.modalService, this.msg);
        row['erreurChamps'] = true;
        return false;
      }
    }

    if (row.add || row.editLigne) {
      this.personnel['listeContrat'].forEach(elt => {
        const debut = moment(elt.dateDebut, 'DD/MM/YYYY');
        const fin = moment(elt.dateFin, 'DD/MM/YYYY');
        if ((row.editLigne && (row.id !== elt.id)) || row.add) {
          if (!elt.add && (moment(row.dateDebutEdit, 'DD/MM/YYYY').isBetween(debut, fin, null, '[]') ||
            moment(row.dateFinEdit, 'DD/MM/YYYY').isBetween(debut, fin, null, '[]'))) {
            date = true;
            dateD = elt.dateDebut;
            dateF = elt.dateFin;
          }
        }
      });

      if (!date) {
        row.editLigne = false;
        delete row.add;
        row.site = Object.assign({}, row.siteEdit);
        if (this.isCycleTravail) {
          row.cycleTravail = Object.assign({}, row.cycleTravailEdit);
          if (row.cycleTravail && row.cycleTravail.id > 0) {
            row.dateDebutCycleTravail = row.dateDebutCycleTravailEdit;
          } else {
            row.dateDebutCycleTravail = '';
          }
        }
        row.qualification = Object.assign({}, row.qualificationEdit);
        row.numContrat = row.numContratEdit;
        row.dateDebut = row.dateDebutEdit;
        row.dateFin = row.dateFinEdit;
        if (this.personnel['listeContrat'].length) {
          const getSite = this.personnel['listeContrat'][this.personnel['listeContrat'].length - 1];
          this.personnel['clefSite'] = getSite && getSite.site ? getSite.site.id : this.personnel['clefSite'];
        }
      } else {
        this.error = 'Les dates que vous avez saisies se chevauchent avec ' + dateD + ' - ' + dateF;
        this.common.openModal(this.modalService, this.msg);
      }
    } else {
      row.editLigne = false;
      delete row.add;
      row.site = Object.assign({}, row.siteEdit);
      if (this.isCycleTravail) {
        row.cycleTravail = Object.assign({}, row.cycleTravailEdit);
        if (row.cycleTravail && row.cycleTravail.id > 0) {
          row.dateDebutCycleTravail = row.dateDebutCycleTravailEdit;
        } else {
          row.dateDebutCycleTravail = '';
        }
      }
      row.qualification = Object.assign({}, row.qualificationEdit);
      row.numContrat = row.numContratEdit;
      row.dateDebut = row.dateDebutEdit;
      row.dateFin = row.dateFinEdit;
      if (this.personnel['listeContrat'].length) {
        const getSite = this.personnel['listeContrat'][this.personnel['listeContrat'].length - 1];
        this.personnel['clefSite'] = getSite && getSite.site ? getSite.site.id : this.personnel['clefSite'];
      }
    }
  }

  revertModif(row) {
    row.editLigne = false;
    delete row.siteEdit;
    delete row.cycleTravailEdit;
    delete row.startCycleTravail;
    delete row.qualificationEdit;
    delete row.numContratEdit;
    delete row.dateDebutEdit;
    delete row.dateDebutCycleTravailEdit;
    delete row.dateFinEdit;
    delete row.start;
    delete row.end;

    if (row.add) {
      this.personnel['listeContrat'] = this.personnel['listeContrat'].filter(elt => elt !== row)
    }

  }

  getListQualification() {
    this.common.post('', {
      param: {
        'servlet': 'DBGestionQualificationPersonnel',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'false',
        'data': {
          'OPERATION': {
            'typeParam': 'int',
            'valeur': 2
          }
        }
      }
    }).then(datas => {
      this.listeQualif = datas.data || [];
      this.searchSite();
    }).catch(error => console.log(error));
  }

  searchZone(event?) {
    this.resultZone = [];
    this.common.post('', {
      param: {
        'servlet': 'DBGetListZone',
        'module': 'Recylog',
        'type': 'liste',
        'compression': 'false',
        'data': ['DBGetListZone']
      }
    }).then(datas => {
      const data = datas.data || [];
      if (data) {
        for (const i in data[0]) {
          if (data[1].length && data[0].length) {
            this.resultZone.push({ id: parseInt(data[1][i], 10), libelle: data[0][i], libelleObjetEntite: data[0][i] });
          }
        }
      }
    }).catch(error => console.log(error));
  }

  colorPickerChange() {
    this.visionCouleur = true;
  }

  onChangeColorPrs(color: string, row): Cmyk {
    this.visionCouleur = true;
    this.personnel['couleur'] = color;
    const hsva = this.cpService.stringToHsva(color);
    const rgba = hsva ? this.cpService.hsvaToRgba(hsva) : null;

    return rgba ? this.cpService.rgbaToCmyk(rgba) : null;
  }

  borderColorPrs(u) {
    return `5px solid ${u.couleur}`;
  }

  selectMateriel(event) {
    this.SearchCarract = 'default';
    this.personnel.camion = event;
  }

  searchChauffeur(event) {

    const param = 41;

    return this.common.appelComboK3Fct(param, event).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        this.listChauffeur = [...[{ id: 0, libelleObjetEntite: 'Non définis' }], ...datas.data];
      }
    });
  }

  getDocsChauffeur(clefChauffeur: number) {
    const param = {
      'servlet': 'DBGestionDocChauffeur',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 4
        },
        'CLEF_CHAUFFEUR': {
          'typeParam': 'int',
          'valeur': clefChauffeur
        }
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        this.documents = datas.data || [];
      }
    });
  }

  deleteLigneDocument(document: any) {
    this.documentSelected = document;
    this.common.openModal(this.modalService, this.supprimerDocumentConfirme);
  }

  imprimerDocChauffeur(clefDocument: number) {

    const param = {
      'servlet': 'DBGestionDocChauffeur',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'pathImpression': 'Recylog/tmp/',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 3
        },
        'ID_DOC': {
          'typeParam': 'int',
          'valeur': clefDocument
        }
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        if (datas.data) {
          const nomFichierChauffeur = datas.data[0] || '';
          this.common.openFile(nomFichierChauffeur);
        }
      }
    });
  }

  supprimerDocument() {
    if (this.documentSelected) {
      this.documentSelected.nomclass = 'FileObject';
      this.documentSelected.clefObjetParent = this.personnel ? this.personnel['id'] : 0;

      const param = {
        'servlet': 'DBGestionDocChauffeur',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'false',
        'data': {
          'OPERATION': {
            'typeParam': 'int',
            'valeur': 2
          },
          'DOCUMENT': this.documentSelected
        }
      };

      return this.common.post('', { param: param }).then(datas => {
        if (this.common.verifySession(datas)) {
          if (datas.data) {
            const documentId = this.documentSelected.id || 0;
            this.documents = this.documents.filter(obj => obj.id !== documentId);
          }
        }
      });
    }
  }

  addLigneDocument() {

    this.documents.push({ id: 0, editLigne: true })
    this.documents = [...this.documents]
  }

  ajouterDocument(document: any) {
    document['clefObjetParent'] = this.personnel ? this.personnel['id'] : 0;
    document.nomclass = 'FileObject';
    document.nomFichierOriginal = this.objFileObject.nomFichierOriginal
    document.nomFichier = this.objFileObject.nomFichier
    document.contentBase64 = this.objFileObject.contentBase64

    const param = {
      'servlet': 'DBGestionDocChauffeur',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'DOCUMENT': document
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        console.log(">>> " + datas.data);
        const idDoc = datas.data;
        if (idDoc > 0) {
          document.id = idDoc;
          document.editLigne = false;
        } else {
          this.error = 'Des erreurs surviennent lors  de l\'enregistrement du document.';
          this.common.openModal(this.modalService, this.msg);
        }
      }
    });
  }

  revertUpateDocument(document: any) {
    this.documents = this.documents.filter(obj => obj.id !== document.id);
  }

  getNameFile(event, item) {
    const ctrl = this
    const file = event.target.files[0];

    if (!this.common.checkExtFichierImgEtTexte(file.name)) {
      this.error = this.common.msgErreurExtensionFichier;
      this.common.openModal(this.modalService, this.msg);
      return;
    }

    console.log('file.name : ' + file.name);
    if (file.name && file.name.includes('.pdf')) {
      item.nomFichierOriginal = file.name;
      item.nomFichier = file.name;

      const fileReader = new FileReader();
      fileReader.onload = function () {
        const base64 = (<string>fileReader.result).split(',');
        item.contentBase64 = base64[1];
      };


      ctrl.objFileObject = item
      fileReader.readAsDataURL(file);
    } else {
      this.error = 'Veuillez sélectionner un fichier PDF.';
      this.common.openModal(this.modalService, this.msg);
    }
  }

  getTypeDoc() {
    this.typeDocuments = [{ id: 0, libelleObjetEntite: 'Autre', libelle: 'Autre' }];
    const list = this.common.getType('listeTypeDoc') || [];
    list.forEach(elt => {
      elt.libelleObjetEntite = elt.libelle;
      this.typeDocuments.push(elt);
    });
  }


  showJourTravailler() {
    this.common.openModal(this.modalService, this.JoursTravaille);
  }

  selectedSemaine(list, elem) {
    list = list || [];
    const listfilter = list.filter(elt => parseInt(elt, 10) === parseInt(elem, 10));
    return listfilter.length ? true : false;
  }

  checkDayWeek(list, elem) {
    // let list = [];

    const listfilter = list.filter(elt => parseInt(elt, 10) === parseInt(elem, 10));
    if (listfilter.length) {
      let index;
      list.forEach((elt, idx) => {
        if (parseInt(elt, 10) === parseInt(elem, 10)) {
          index = idx;
        }
      });
      // const index = list.indexOf('' + 5);
      list.splice(index, 1);
      list = [...list];
    } else {
      list.push('' + elem);
      list = [...list];
    }
  }


  addLigneArtImport() {
    this.personnel['listeArticleImport'] = this.personnel['listeArticleImport'] || [];
    this.personnel['listeArticleImport'].push({
      id: '0',
      // pending: false,
      // editLigne: true
    });
    const length = this.personnel['listeArticleImport'].length - 1;
    this.personnel['listeArticleImport'] = [...this.personnel['listeArticleImport']];
    setTimeout(function () {
      $('.article' + (length)).focus();
    }, 600);
  }



  searchArticle(event) {
    this.dataArticle = [{ id: 0, libelle: 'Tous', libelleObjetEntite: 'Tous' }];
    const param = 1;

    return this.common.appelComboK3Fct(param, event).then(datas => {
      // $('#autocomplete').trigger('click');
      if (datas.data) {
        this.dataArticle = [...this.dataArticle, ...datas.data];
      } else {
        if (datas.message) {
          if (datas.message.includes('Utilisateur non authentifié')) {
            this.common.removeConnection();
          }
        }
      }
    });
  }

  // saveArtImport(row) {
  //   row.editLigne = false;
  // }

  // modifLigneArtImport(row) {
  //  row.editLigne = true;
  // }

  deleteLigneArtImport(row) {
    const temp = this.personnel['listeArticleImport'].filter(elt => elt !== row);
    this.personnel['listeArticleImport'] = temp;
  }

  showPrestationAssociees() {
    this.listePrestationAssociees = [];
    this.isPrestationAssociees = !this.isPrestationAssociees;
    if (this.isPrestationAssociees) {
      this.personnel['prestationAssociees'] = this.personnel['prestationAssociees'] || [];
      this.personnel['prestationAssociees'].forEach(elt => {
        elt.libelleObjetEntite = elt.code;
        this.listePrestationAssociees.push(Object.assign({}, elt));
      });
      console.log(this.listePrestationAssociees);
    }
  }

  savePrestationAssociees() {
    this.personnel['prestationAssociees'] = this.listePrestationAssociees;
    this.personnel['prestationAssociees'].forEach(elt => {
      elt.nomClass = 'Article';
    });
    this.showPrestationAssociees();
  }

  deletePrestationAssociees(row) {
    const temp = this.listePrestationAssociees.filter(elt => elt !== row);
    this.listePrestationAssociees = temp;
  }

  addPrestationAssociees() {
    this.listePrestationAssociees = this.listePrestationAssociees || [];
    this.listePrestationAssociees.push({
      id: '0',
      edit: true
    });
    this.listePrestationAssociees = [...this.listePrestationAssociees];
  }

  setLibellePrestationAssocie(event, rowIndex) {
    const row = this.listePrestationAssociees[rowIndex];
    this.getDetailArticle(event.id).then(data => {
      if (data !== null) {
        this.listePrestationAssociees[rowIndex] = data[0];
        this.listePrestationAssociees[rowIndex].edit = row.edit;
        this.listePrestationAssociees[rowIndex].libelleObjetEntite = this.listePrestationAssociees[rowIndex].code;
        this.listePrestationAssociees = [...this.listePrestationAssociees];
      }
    });
  }

  getDetailArticle(id) {
    const clef = '' + id;
    const param = {
      'servlet': 'DBGetArticle',
      'module': 'Recylog',
      'type': 'tableau',
      'compression': 'false',
      'data': ['DBGetArticle', clef, 0, moment().format('DD/MM/YYYY'), 0, 0, 0, 0, 0,
        this.common.user[2], '0']
    };
    return this.common.post('', { param: param }).then(datas => {
      return datas.data;
    });
  }

  searchFiliereDepartement() {
    this.listFiliereFact = [{ id: 0, libelleObjetEntite: 'Aucune', libelle: 'Aucune' }];
    const list = this.common.getType('typefiliere') || [];
    list.forEach(elt => {
      elt.libelleObjetEntite = elt.libelle;
      this.listFiliereFact.push(elt);
    });
  }

  showInput(index?) {
    const ctrl = this;
    $('ngx-datatable .datatable-body').scrollTop(0);
    setTimeout(function () {
      if (index) {
        ctrl.common.focusElement('#filiereFact' + index);
      } else {
        ctrl.common.focusElement('#filiereFact' + (index || 0));
      }
    }, 510);
  }

  showFiliereDepartement() {
    this.listeFiliereDepartement = [];
    this.isFiliereDepartement = !this.isFiliereDepartement;
    if (this.isFiliereDepartement) {
      this.personnel['listDepartementFiliereFact'] = this.personnel['listDepartementFiliereFact'] || [];
      this.personnel['listDepartementFiliereFact'].forEach(elt => {
        elt.libelleObjetEntite = elt.libelle;
        this.listeFiliereDepartement.push(Object.assign({}, elt));
      });
      console.log(this.listeFiliereDepartement);
    }
  }

  saveFiliereDepartement() {
    this.personnel['listDepartementFiliereFact'] = this.listeFiliereDepartement;
    this.personnel['listDepartementFiliereFact'].forEach(elt => {
      elt.nomClass = 'FiliereFact';
    });
    this.showFiliereDepartement();
  }

  deleteFiliereDepartement(row) {
    const temp = this.listeFiliereDepartement.filter(elt => elt !== row);
    this.listeFiliereDepartement = temp;
  }

  addFiliereDepartement() {
    this.listeFiliereDepartement = this.listeFiliereDepartement || [];
    this.listeFiliereDepartement.push({
      id: '0',
      edit: true
    });
    this.listeFiliereDepartement = [...this.listeFiliereDepartement];
  }

  setFiliereDepartement(event, rowIndex) {
    const row = this.listeFiliereDepartement[rowIndex];
    this.listeFiliereDepartement[rowIndex] = event;
    this.listeFiliereDepartement[rowIndex].edit = row.edit;
    this.listeFiliereDepartement[rowIndex].departement = row.departement;
    this.listeFiliereDepartement = [...this.listeFiliereDepartement];
  }

  addLigneExuImport() {
    this.personnel['listeExutoireImport'] = this.personnel['listeExutoireImport'] || [];
    this.personnel['listeExutoireImport'].push({
      id: '0',
      // pending: false,
      // editLigne: true
    });
    const length = this.personnel['listeExutoireImport'].length - 1;
    this.personnel['listeExutoireImport'] = [...this.personnel['listeExutoireImport']];
    setTimeout(function () {
      $('.article' + (length)).focus();
    }, 600);
  }



  searchExutoireImp(event) {
    this.dataExutoire = [];
    const param = 6;

    return this.common.appelComboK3Fct(param, event).then(datas => {
      // $('#autocomplete').trigger('click');
      if (datas.data) {
        this.dataExutoire = [...this.dataExutoire, ...datas.data];
      } else {
        if (datas.message) {
          if (datas.message.includes('Utilisateur non authentifié')) {
            this.common.removeConnection();
          }
        }
      }
    });
  }

  // saveArtImport(row) {
  //   row.editLigne = false;
  // }

  // modifLigneArtImport(row) {
  //  row.editLigne = true;
  // }

  deleteLigneExuImport(row) {
    const temp = this.personnel['listeExutoireImport'].filter(elt => elt !== row);
    this.personnel['listeExutoireImport'] = temp;
  }

  addLigneZoneImport() {
    this.personnel['listeZoneProvenanceImport'] = this.personnel['listeZoneProvenanceImport'] || [];
    this.personnel['listeZoneProvenanceImport'].push({
      id: '0',
      // pending: false,
      // editLigne: true
    });
    const length = this.personnel['listeZoneProvenanceImport'].length - 1;
    this.personnel['listeZoneProvenanceImport'] = [...this.personnel['listeZoneProvenanceImport']];
    setTimeout(function () {
      $('.article' + (length)).focus();
    }, 600);
  }

  deleteLigneZoneImport(row) {
    const temp = this.personnel['listeZoneProvenanceImport'].filter(elt => elt !== row);
    this.personnel['listeZoneProvenanceImport'] = temp;
  }

  resultZoneProvenance = [];
  searchZoneProvenance(event?) {
    this.resultZoneProvenance = [];

    const param = 51;

    return this.common.appelComboK3Fct(param, event).then(datas => {
      // $('#autocomplete').trigger('click');
      if (datas.data !== null) {
        this.resultZoneProvenance = datas.data || [];
      } else {
        if (datas.message) {
          if (datas.message.includes('Utilisateur non authentifié')) {
            this.common.removeConnection();
          }
        }
      }
    });
  }

  onEcobm2JChange() {
    if (this.personnel.ecobm2J && this.personnel.ecobm4J) {
      this.personnel.ecobm4J = false;
    }
  }

  onEcobm4JChange() {
    if (this.personnel.ecobm2J && this.personnel.ecobm4J) {
      this.personnel.ecobm2J = false;
    }
  }

  changerInterime() {
    if (this.personnel['interimaire']) {
      this.personnel['typeContratPersonnel'] = this.listTypeContrat[0];
    }
  }

}
